import { defaultNumberFormatOptions, defaultKwhFormatOptions, defaultKwpFormatOptions } from '@/constants'

const formatNumber = (
	value, 
	options = defaultNumberFormatOptions, 
	locale
) => {
  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(value)
}

export const formatKwh = (
	value,
	generalKwh = 'kWh',
	locale,
	maximumFractionDigits = defaultKwhFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultKwhFormatOptions.minimumFractionDigits
) => {
  if (!isNaN(value)) {
    const amount = formatNumber(
      value,
      {
        minimumFractionDigits,
        maximumFractionDigits
      },
      locale
    )
    return `${amount} ${generalKwh}`
  }
  return `${value} ${generalKwh}`
}

export const formatKwp = (
	value,
	locale,
	// generalWp,
	maximumFractionDigits = defaultKwpFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultKwpFormatOptions.minimumFractionDigits
) => {
  const amount = formatNumber(
    value * defaultKwpFormatOptions.multiplier,
    {
      minimumFractionDigits,
      maximumFractionDigits
    },
    locale
  )
  return amount
}

export const formatMileage = (
	value,
	locale,
	generalKm = 'km',
	maximumFractionDigits = defaultNumberFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultNumberFormatOptions.minimumFractionDigits
) => {
  const amount = formatNumber(
    value,
    {
      minimumFractionDigits,
      maximumFractionDigits
    },
    locale
  )
  return `${amount} ${generalKm}`
}

export const formatPercentage = (
	value,
	locale,
	maximumFractionDigits = defaultNumberFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultNumberFormatOptions.minimumFractionDigits
) => {
  const percentage = value / 100
  const amount = formatNumber(
    percentage,
    {
      style: 'percent',
      minimumFractionDigits,
      maximumFractionDigits
    },
    locale
  )
  return `${amount}`
}

export const formatWeight = (
	value,
	locale,
	generalKg = 'kg',
	maximumFractionDigits = defaultNumberFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultNumberFormatOptions.minimumFractionDigits
) => {
  const amount = formatNumber(
    value,
    {
      minimumFractionDigits,
      maximumFractionDigits
    },
    locale
  )
  return `${amount} ${generalKg}`
}

export function formatCurrency(
	value,
	locale,
	currencyCode,
	fractionDigits = defaultNumberFormatOptions.maximumFractionDigits,
	amountConnector
) {
  if (!currencyCode) {
    return value
  }
  if (Array.isArray(value)) {
    return value
      .map((n) => formatCurrency(n, locale, currencyCode, fractionDigits, amountConnector))
      .join(` ${amountConnector} `)
  }

  const amount = formatNumber(
    value,
    {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    },
    locale
  )
  return amount
}

export const formatAmount = (
	value,
	locale,
	maximumFractionDigits = defaultNumberFormatOptions.maximumFractionDigits,
	minimumFractionDigits = defaultNumberFormatOptions.minimumFractionDigits
) => {
  const amount = formatNumber(
    value,
    {
      minimumFractionDigits,
      maximumFractionDigits
    },
    locale
  )
  return `${amount}`
}
